
import Vue from "vue";
import axios from "axios";
import Top from "@/components/templates/Top.vue";
import config from "@/config.js";
import {mapGetters } from 'vuex';
export default Vue.extend({
  name: "ClickToCall",
  components: {
    Top,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      hoverColor: 'lookAndFeel/hoverColor',
      menuIconColor: 'lookAndFeel/menuIconColor',
      menuFontColor: 'lookAndFeel/menuFontColor',  
    }),
  },
  data() {
    return {
      clickToCall: {
        exten: "",
        destination: "",
        key: "",
        passwd: "",
      },
      showPass: false,
      token: "",
      formValid: false,
      rules: {
        required: (value) => !!value || this.$t("loginView.required"),
        isNumber: (value) => /^\d+$/.test(value) || this.$t("rules.alphanum"),
      },
    };
  },
  methods: {
    goToSearch() {
      this.$router.push({ name: "clickToCallTable" });
    },
    async handleSubmit() {
      if (this.$refs.form.validate()) {
        this.token = axios.post("http://192.168.0.131:8081/discador/public/api/login", {
          user: this.user.nick,
          password: this.clickToCall.passwd, 
        });
        const response = axios.post("http://192.168.0.131:8081/discador/public/api/makecall", this.clickToCall, {
					headers: {
						Authorization: `Bearer ${this.token}`,
					},
				});
				this.$refs.form.reset();
        this.clickToCall = {
					exten: "",
        	destination: "",
        	key: "",
				}
      }
    },
  },
});
